import React from "react";
import styled, { css } from "styled-components";

const TabHeadingOuter = styled.div<ITabHeadingOuter>`
  border-top-left-radius: ${({ theme }) => theme.radii[1]};
  border-top-right-radius: ${({ theme }) => theme.radii[1]};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.white};
  ${(props) =>
    props.isCentered &&
    css`
      text-align: center;
    `}
`;

const TabHeadingInner = styled.div<ITabHeadingInner>`
  display: inline-block;
  padding: 0 ${({ theme }) => theme.space[1]};
  border-top-left-radius: ${({ theme }) => theme.radii[1]};
  border-top-right-radius: ${({ theme }) => theme.radii[1]};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    ${(props) =>
      props.isBlock &&
      css`
        display: block;
      `}
  }
`;

const TabHeadingTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-family: ${({ theme }) => theme.fonts.book};
  font-weight: 400;
`;

interface IOwnProps {
  title: React.ReactNode;
}

interface ITabHeadingOuter {
  isCentered?: boolean;
}

interface ITabHeadingInner {
  isBlock?: boolean;
}

type Props = IOwnProps & ITabHeadingOuter & ITabHeadingInner;

const TabHeading: React.FC<Props> = ({
  isBlock = false,
  isCentered = false,
  title,
}) => (
  <TabHeadingOuter isCentered={isCentered}>
    <TabHeadingInner isBlock={isBlock}>
      <TabHeadingTitle>{title}</TabHeadingTitle>
    </TabHeadingInner>
  </TabHeadingOuter>
);

export default TabHeading;
